module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-plant"
  }, [_c('div', {
    staticClass: "single-plant__scroll-container"
  }, [(_vm.content) ? _c('div', {
    staticClass: "single-plant__container"
  }, [_c('div', {
    staticClass: "single-plant__wrapper"
  }, [_c('div', {
    ref: "plantText"
  }, [_c('h2', {
    staticClass: "single-plant__subtitle"
  }, [_vm._v("Aujourd'hui, la plante qu'il vous faut est :")]), _vm._v(" "), _c('h1', {
    staticClass: "single-plant__title"
  }, [_vm._v(_vm._s(_vm.content.title))]), _vm._v(" "), _c('p', {
    staticClass: "single-plant__description"
  }, [_vm._v(_vm._s(_vm.content.desc))])]), _vm._v(" "), _c('div', {
    staticClass: "single-plant__sharing"
  }, [_c('p', {
    staticClass: "sharing__text"
  }, [_vm._v("Partagez votre plante prodigieuse :")]), _vm._v(" "), _c('div', {
    staticClass: "sharing__btns"
  }, [_c('ui-button', {
    attrs: {
      "shareInfos": _vm.shareInfos,
      "type": "facebook"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "shareInfos": _vm.shareInfos,
      "type": "twitter"
    }
  })], 1)]), _vm._v(" "), _c('ui-button-to-home', {
    attrs: {
      "goToFilters": true
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "canvas",
    staticClass: "single-plant__canvas-container"
  })]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "single-plant__container single-plant__container--error"
  }, [_c('h1', [_vm._v("Erreur " + _vm._s(_vm.error.code))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.error.msg))])]) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('artwork', {
    ref: "artwork",
    attrs: {
      "prefix": ((_vm.plant.id) + "_" + (_vm.plant.title)),
      "oeuvre": _vm.content.oeuvre
    }
  }) : _vm._e(), _vm._v(" "), _c('ui-footer', {
    ref: "uiFooter"
  }), _vm._v(" "), (_vm.nav) ? _c('div', {
    staticClass: "single-plant__nav"
  }, [_c('navigation-button', {
    attrs: {
      "slug": _vm.nav.prev,
      "direction": "prev"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tweenContent('prev')
      }
    }
  }), _vm._v(" "), _c('navigation-button', {
    attrs: {
      "slug": _vm.nav.next,
      "direction": "next"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tweenContent('next')
      }
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-0255c219!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SinglePlant/index.vue
 ** module id = 745
 ** module chunks = 2
 **/